/**
 * Fila cega (hide_pending_content por canal): quando o canal tem a flag ligada,
 * atendente NÃO-admin não vê a prévia da última mensagem (lista) nem a conversa
 * de tickets PENDENTES até ACEITAR. Admin vê tudo.
 *
 * A conversa é bloqueada no servidor (GET /tickets/:id/messages → 403); esta
 * helper é a mesma regra no cliente pra ocultar a prévia no card e mostrar o
 * placeholder na thread.
 */
export function isPendingContentHidden(
  channelHidePendingContent: boolean | undefined,
  ticketStatus: string,
  userProfile: string | undefined,
): boolean {
  return (
    channelHidePendingContent === true && ticketStatus === 'pending' && userProfile !== 'admin'
  );
}
